//======================
// Errors Actions
//======================
export const CREATE_ERROR = 'CREATE_ERROR';
export const DELETE_ERROR = 'DELETE_ERROR';
export const ERROR_RESPONSE = 'ERROR_RESPONSE';


// WEBPACK FOOTER //
// ./src/actionTypes/error.js